import { render, staticRenderFns } from "./PdfFilePreview.vue?vue&type=template&id=db2e2152"
import script from "./PdfFilePreview.vue?vue&type=script&lang=js"
export * from "./PdfFilePreview.vue?vue&type=script&lang=js"
import style0 from "./PdfFilePreview.vue?vue&type=style&index=0&id=db2e2152&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports